import request from '@/utils/request'


// 查询平台账单记录
export function billRecordList(data) {
  return request({
    url: '/web/bill/record/list',
    method: 'post',
    data
  })
}

// 查询流水记录列表（config 可传 timeout 等 axios 配置，导出大批量数据时使用）
export function billSerialList(data, config = {}) {
  return request({
    url: '/web/serial/list',
    method: 'post',
    data,
    ...config,
  })
}

// 查询商户账单记录
export function billMerchantList(data) {
  return request({
    url: '/web/bill/merchant/list',
    method: 'post',
    data
  })
}

// 查询渠道账单记录
export function billChannelList(data) {
  return request({
    url: '/web/bill/channel/list',
    method: 'post',
    data
  })
}

// 查询门店账单记录
export function billStoreList(data) {
  return request({
    url: '/web/bill/store/list',
    method: 'post',
    data
  })
}

// 核心指标展示
export function coreDisplay(data) {
  return request({
    url: '/web/core/display',
    method: 'post',
    data
  })
}

// 平台管理员账号列表
export function platformAdminList(data) {
  return request({
    url: '/web/platform/admin/list',
    method: 'post',
    data: data || {}
  })
}

// 新增财务/运营平台账号
export function platformAdminCreate(data) {
  return request({
    url: '/web/platform/admin/create',
    method: 'post',
    data
  })
}

// 停用/启用平台账号
export function platformAdminStatus(data) {
  return request({
    url: '/web/platform/admin/status',
    method: 'post',
    data
  })
}